import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIO_PERFIL_SALVAR_BEGIN,
  USUARIO_PERFIL_SALVAR_SUCCESS,
  USUARIO_PERFIL_SALVAR_FAILURE,
  USUARIO_PERFIL_SALVAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function salvar(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIO_PERFIL_SALVAR_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissSalvarError() {
  return {
    type: USUARIO_PERFIL_SALVAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIO_PERFIL_SALVAR_BEGIN actions
export function* doSalvar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioPerfilApi = new Services['UsuarioPerfilApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioPerfilApi.patchOrCreate(action.data);
  } catch (err) {
    yield put({
      type: USUARIO_PERFIL_SALVAR_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIO_PERFIL_SALVAR_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIO_PERFIL_SALVAR_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIO_PERFIL_SALVAR_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchSalvar() {
  yield takeLatest(USUARIO_PERFIL_SALVAR_BEGIN, doSalvar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIO_PERFIL_SALVAR_BEGIN:
      return {
        ...state,
        salvarPending: true,
        salvarError: null,
      };

    case USUARIO_PERFIL_SALVAR_SUCCESS:
      return {
        ...state,
        registro: action.data,
        salvarPending: false,
        salvarError: null,
      };

    case USUARIO_PERFIL_SALVAR_FAILURE:
      return {
        ...state,
        salvarPending: false,
        salvarError: action.data.error,
      };

    case USUARIO_PERFIL_SALVAR_DISMISS_ERROR:
      return {
        ...state,
        salvarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/salvar.js